import React from 'react';
import Classnames from 'classnames';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';
import couponImg from './assets/coupon.svg';
import { formatWelcomeGiftValue } from '../../cashback/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    background: `url(${couponImg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    padding: theme.spacing(2, 0),
    fontSize: '1.8rem',
    fontWeight: 600,
    textAlign: 'center',
    color: '#28292c',
  },
}));

type Props = {
  className?: string
}

const WelcomeDiscountCoupon: React.FC<Props> = observer(({ className }) => {
  const classes = useStyles();

  return !AppWelcomeGiftStore.welcomeGift ? null : (
    <div className={Classnames(className, classes.root)}>{formatWelcomeGiftValue(AppWelcomeGiftStore.welcomeGift)}</div>
  );
});

export default WelcomeDiscountCoupon;
